import { Vue, Component, Watch, Prop, Provide } from 'vue-property-decorator';
import style from './style.vue';
import { defaultImg } from '@/views/components/newDisplayConfig/shop';

@Component({
  components: {},
  mixins: [style],
})
export default class Propagate extends Vue {
  @Prop({ default: () => {} })
    value: DisplayPropagateData | NewDisplayShopAd;

  @Prop({ default: 1 })
    themeCode: number;

  // 轮播图
  curIndex = 0;
  imgHeight = 150;
  changeIndex(e) {
    this.curIndex = e;
    const width = this.value.desc.list[this.curIndex].width;
    const height = this.value.desc.list[this.curIndex].height;
    this.imgHeight = (350 / width) * height;
  }

  imgList = [];

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    this.value = n;
    this.value.desc.pStyle == 1 && this.value.desc.list && this.value.desc.list.length > 0 && (this.imgHeight = (350 / this.value.desc.list[this.curIndex].width) * this.value.desc.list[this.curIndex].height);
    this.value.desc.list && this.value.desc.list.length > 0 ? (this.imgList = this.value.desc.list) : (this.imgList = []);
  }

  // 运营模式 1 镜单  2 镜千 3 云单 4 云千
  @Provide()
  get mode() {
    return Number(+this.$route.params.mode);
  }

  @Provide()
  get isMoreSite() {
    return Number(+this.$route.params.isMoreSite);
  }

  // 字体颜色
  get fontColor() {
    return this.themeCode > 3 ? '#ffffff' : '#000000';
  }

  render(h) {
    const mapArr = new Array(this.value.desc.pStyle == 1 ? 1 : this.value.desc.pMaxPage).fill(1);
    const maxHeight = Math.max(...this.imgList.map(v => v.height));
    const maxWidth = Math.max(...this.imgList.map(v => v.width));
    const Height = (300 / maxWidth) * maxHeight + 200;
    return (
      <div
        class={{ 'propagate': true, 'no-wrap': this.value.desc.pStyle == 2, 'wrap': this.value.desc.pStyle == 3 }}
        style={`padding: ${this.value.desc.pStyle !== 1 ? this.value.desc.margin / 4 : this.value.desc.margin / 2}px;
          display: ${this.value.desc.pStyle == 2 ? 'flex' : 'block'}`}>
        {/* 云商城装修 */}
        {this.mode == 2
          && this.value.desc.pStyle != 1
          && this.imgList.length > 0
          && this.imgList.map((val, i) => {
            return (
              <div
                class="mode-item"
                style={`
                padding:${this.value.desc.margin / 4}px;
                position: relative;
                ${this.value.desc.pStyle == 2 ? 'min-width:330px' : ''}`}>
                {/* 一行一图有min-width会超出宽度 */}
                <div
                  class="propagate-item"
                  key={i}
                  style={`border-radius: ${this.value.desc.borderRadius / 2}px;
                    background-image: url('${val.advPic || defaultImg}');
                    height:${val.width ? (350 / val.width) * val.height : 350}px;
                    `}>
                  {/* margin-top:${this.value.desc.pStyle == 2 ? (Height - (300 / val.width) * val.height) / 2 : 0}px */}
                  {this.value.desc.displayType === 1 && (
                    <div
                      class="mode-propagate-title-inner"
                      style={`text-shadow: ${this.value.desc.displayType == 1 ? '0 0 12px rgba(0,0,0,.8)' : ''};color:${this.value.desc.displayType == 1 ? '#ffffff' : this.fontColor};`}
                      {...{
                        domProps: {
                          innerHTML: val.advTitle,
                        },
                      }}></div>
                  )}
                </div>
                {this.value.desc.displayType === 2 && val.advPic && (
                  <div
                    class="propagate-title-out"
                    style={`color:${this.fontColor};`}
                    {...{
                      domProps: {
                        innerHTML: val.advTitle,
                      },
                    }}>
                    {/* {val.advTitle} */}
                  </div>
                )}
              </div>
            );
          })}
        {this.mode == 2 && this.value.desc.pStyle == 1 && this.imgList.length > 0 && (
          <div class="mode-item">
            {/* interval={5000}  height="150px" */}
            <el-carousel class="carousel" height={`${this.imgHeight}px`} autoplay={false} onChange={this.changeIndex.bind(this)}>
              {this.imgList.map((val, i) => {
                return (
                  <el-carousel-item key={i}>
                    <img class="carousel-img" src={val.advPic || defaultImg} style={`border-radius: ${this.value.desc.borderRadius / 2}px;`} />
                    {this.value.desc.displayType == 1 && (
                      <div
                        class="mode-propagate-title-inner text-white"
                        style="text-shadow: 0 0 12px rgba(0,0,0,.8)"
                        {...{
                          domProps: {
                            innerHTML: val.advTitle,
                          },
                        }}></div>
                    )}
                  </el-carousel-item>
                );
              })}
            </el-carousel>
            {this.value.desc.displayType == 2
              && this.imgList.map((val, i) => {
                return (
                  <div>
                    {this.curIndex === i && (
                      <div
                        class="propagate-title-out"
                        style={`color:${this.fontColor};`}
                        {...{
                          domProps: {
                            innerHTML: val.advTitle,
                          },
                        }}></div>
                    )}
                  </div>
                );
              })}
          </div>
        )}

        {/* 云店装修 */}
        {(this.mode == 1 || this.imgList.length < 1)
          && mapArr.map((val, i) => {
            return (
              <div style={`margin-bottom:${this.value.desc.pStyle === 3 && mapArr[i + 1] ? this.value.desc.margin / 2 : 0}px;position: relative;min-width: ${this.value.desc.pStyle == 2 ? 300 : ''}px;`}>
                <div
                  class="propagate-item bg-grey-2 hei-50"
                  key={i}
                  style={`border-radius: ${this.value.desc.borderRadius / 2}px;
                margin-right: ${this.value.desc.pStyle == 2 ? this.value.desc.margin / 2 : 0}px;
                `}>
                  {this.value.desc.pStyle == 1 && (
                    <div class="swiper-point-container">
                      <div class="swiper-point"></div>
                      <div class="swiper-point"></div>
                      <div class="swiper-point"></div>
                    </div>
                  )}
                </div>
                {this.value.desc.displayType != 3 && (
                  <div
                    class={{
                      'propagate-title-inner': this.value.desc.displayType === 1,
                      'propagate-title-out': this.value.desc.displayType === 2,
                    }}
                    style={`text-shadow: ${this.value.desc.displayType == 1 ? '0 0 12px rgba(0,0,0,.8)' : ''};color:${this.value.desc.displayType == 1 ? '#ffffff' : this.fontColor};`}>
                    千万种姿态<br></br>
                    约见同一种美好
                  </div>
                )}
              </div>
            );
          })}
      </div>
    );
  }
}
